export const students = {
  'students.title': 'الطلاب وأولياء الأمور',
  'students.subtitle': 'المسجّلون هذه السنة: {n}',
  'students.subtitleFiltered': 'النتائج: {n}',
  'students.search': 'ابحث بالاسم أو الرمز أو هاتف ولي الأمر',
  'students.filter.grade': 'الصف',
  'students.filter.allGrades': 'كل الصفوف',
  'students.filter.class': 'الشعبة',
  'students.filter.allClasses': 'كل الشعب',
  'students.filter.status': 'حالة القيد',
  'students.filter.all': 'الكل',
  'students.filter.late': 'متأخر',
  'students.new': 'طالب جديد',
  'students.import': 'استيراد من Excel',
  'students.col.code': 'الرمز',
  'students.col.student': 'الطالب',
  'students.col.class': 'الصف والشعبة',
  'students.col.guardian': 'ولي الأمر',
  'students.col.balance': 'الرصيد المتبقي',
  'students.col.next': 'القسط القادم',
  'students.col.status': 'الحالة',
  'students.empty': 'لا يوجد طلاب بعد',
  'students.emptyBody': 'سجّل أول طالب أو استورد قائمة الطلاب من ملف Excel.',
  'students.emptyFiltered': 'لا يوجد طلاب مطابقون',
  'students.emptyFilteredBody': 'غيّر كلمة البحث أو امسح التصفية.',
  'students.noClass': 'بلا شعبة',
  'students.form.newTitle': 'تسجيل طالب جديد',
  'students.form.newDesc': 'تُضاف رسوم الصف الإلزامية تلقائياً، ويحصل ولي الأمر على حساب في التطبيق برقم هاتفه.',
  'students.form.student': 'بيانات الطالب',
  'students.form.nameAr': 'الاسم الكامل بالعربية',
  'students.form.nameEn': 'الاسم بالإنجليزية',
  'students.form.gender': 'الجنس',
  'students.form.birthDate': 'تاريخ الميلاد',
  'students.form.nationalId': 'رقم الهوية الوطنية',
  'students.form.code': 'رمز الطالب',
  'students.form.codeHint': 'اتركه فارغاً ليُنشأ تلقائياً (S-0001)',
  'students.form.class': 'الصف والشعبة',
  'students.form.startDate': 'تاريخ بدء الدوام',
  'students.form.guardians': 'أولياء الأمور',
  'students.form.guardian': 'ولي الأمر {n}',
  'students.form.addGuardian': 'إضافة ولي أمر',
  'students.form.removeGuardian': 'إزالة ولي الأمر',
  'students.form.guardianName': 'الاسم',
  'students.form.guardianPhone': 'رقم الهاتف',
  'students.form.relation': 'الصلة',
  'students.form.primary': 'جهة الاتصال الرئيسية',
  'students.form.payer': 'يدفع الرسوم',
  'students.form.canViewFees': 'يرى الرسوم في التطبيق',
  'students.form.canViewFeesHint': 'أطفئها لولي أمر لا يُسمح له برؤية الرسوم (حالات الانفصال مثلاً).',
  'students.form.create': 'تسجيل الطالب',
  'students.form.created': 'سُجّل الطالب {name}',
  'students.form.editTitle': 'تعديل بيانات الطالب',
  'students.form.noClasses': 'لا توجد شعب في السنة الحالية. أنشئ الشعب من الإعدادات أولاً.',
  'students.detail.profile': 'البيانات الشخصية',
  'students.detail.guardians': 'أولياء الأمور',
  'students.detail.enrollments': 'سجل القيد',
  'students.detail.current': 'الحالية',
  'students.detail.ended': 'انتهت · {reason}',
  'students.detail.statement': 'كشف الحساب',
  'students.detail.year': 'السنة الدراسية',
  'students.detail.receive': 'استلام دفعة',
  'students.detail.more': 'إجراءات',
  'students.detail.primary': 'رئيسي',
  'students.detail.payer': 'يدفع',
  'students.detail.noFees': 'لا يرى الرسوم',
  'students.detail.hasApp': 'لديه حساب في التطبيق',
  'students.detail.since': 'منذ {date}',
  'students.sum.charged': 'الرسوم',
  'students.sum.discount': 'الخصومات',
  'students.sum.netDue': 'الصافي بعد الخصم',
  'students.sum.paid': 'المدفوع',
  'students.sum.balance': 'المتبقي',
  'students.sum.overdue': 'المتأخر',
  'students.sum.pending': 'بانتظار التسوية {amount}',
  'students.sum.credit': 'رصيد دائن لولي الأمر',
  'students.inst.title': 'جدول الأقساط',
  'students.inst.seq': 'القسط',
  'students.inst.due': 'تاريخ الاستحقاق',
  'students.inst.amount': 'المبلغ',
  'students.inst.paid': 'المدفوع',
  'students.inst.remaining': 'المتبقي',
  'students.inst.none': 'لا يوجد جدول أقساط',
  'students.inst.noneBody': 'قسّم صافي الرسوم على أقساط بتواريخ استحقاق.',
  'students.inst.set': 'تحديد خطة الأقساط',
  'students.inst.reset': 'تغيير خطة الأقساط',
  'students.charges.title': 'الرسوم المترتبة',
  'students.charges.desc': 'البند',
  'students.charges.opening': 'رصيد افتتاحي',
  'students.charges.cancellation': 'إلغاء',
  'students.charges.cancelled': 'ملغى',
  'students.charges.cancel': 'إلغاء الرسم',
  'students.charges.cancelTitle': 'إلغاء رسم',
  'students.charges.cancelBody': 'يُسجَّل قيد عكسي بالمبلغ نفسه؛ الرسم الأصلي يبقى في السجل.',
  'students.charges.cancelled.ok': 'أُلغي الرسم',
  'students.charges.none': 'لا رسوم مترتبة هذه السنة',
  'students.discounts.title': 'الخصومات',
  'students.discounts.request': 'طلب خصم',
  'students.discounts.none': 'لا خصومات',
  'students.discounts.allFees': 'على كل الرسوم',
  'students.payments.title': 'الوصولات',
  'students.payments.receipt': 'رقم الوصل',
  'students.payments.payer': 'الدافع',
  'students.payments.method': 'الطريقة',
  'students.payments.none': 'لا وصولات هذه السنة',
  'students.action.edit': 'تعديل البيانات',
  'students.action.transfer': 'نقل إلى شعبة أخرى',
  'students.action.withdraw': 'تسجيل انسحاب',
  'students.action.addGuardian': 'إضافة ولي أمر',
  'students.action.opening': 'رصيد افتتاحي',
  'students.action.installments': 'خطة الأقساط',
  'students.action.discount': 'طلب خصم',
  'students.transfer.title': 'نقل الطالب',
  'students.transfer.desc': 'يبقى القيد السابق في السجل، والرسوم لا تتغير.',
  'students.transfer.to': 'الشعبة الجديدة',
  'students.transfer.date': 'تاريخ النقل',
  'students.transfer.done': 'نُقل الطالب',
  'students.withdraw.title': 'تسجيل انسحاب الطالب',
  'students.withdraw.desc': 'يُنهى القيد ويبقى كشف الحساب والرصيد المتبقي كما هو.',
  'students.withdraw.date': 'تاريخ الانسحاب',
  'students.withdraw.confirm': 'تسجيل الانسحاب',
  'students.withdraw.done': 'سُجّل انسحاب الطالب',
  'students.guardian.title': 'إضافة ولي أمر',
  'students.guardian.done': 'أُضيف ولي الأمر',
  'students.opening.title': 'رصيد افتتاحي',
  'students.opening.desc': 'رسوم ما زالت مستحقة قبل بدء العمل بالنظام (مدرسة انضمت في منتصف السنة).',
  'students.opening.description': 'الوصف',
  'students.opening.descriptionDefault': 'رصيد افتتاحي',
  'students.opening.done': 'أُضيف الرصيد الافتتاحي',
  'students.plan.title': 'خطة الأقساط',
  'students.plan.desc': 'يُقسَّم صافي رسوم السنة ({amount}) على الأقساط بتقريب {unit}، والفرق على القسط الأخير. تُستبدل الخطة الحالية.',
  'students.plan.count': 'عدد الأقساط',
  'students.plan.first': 'تاريخ أول قسط',
  'students.plan.interval': 'كل كم شهر',
  'students.plan.preview': 'المعاينة',
  'students.plan.previewLine': '{n} × {amount}',
  'students.plan.previewLast': 'والأخير {amount}',
  'students.plan.done': 'حُفظت خطة الأقساط',
  'students.plan.noNet': 'لا توجد رسوم صافية لجدولتها هذه السنة.',
  'students.edit.done': 'حُفظت بيانات الطالب',
  'students.feesOff': 'الرسوم متوقفة في هذه المدرسة؛ كشف الحساب مخفي.',
  'students.import.title': 'استيراد الطلاب من Excel',
  'students.import.step1Body': 'سطر لكل طالب. الأعمدة الإلزامية: الاسم، الجنس، الصف (رقم ١–١٢)، الشعبة، اسم ولي الأمر وهاتفه. تُقيَّد رسوم هذه السنة من قائمة الرسوم؛ اكتب ديون السنوات السابقة في «ديون سابقة» وما دُفع من هذه السنة قبل تباشير في «المدفوع هذه السنة».',
  'students.import.startDate': 'تاريخ بدء الدوام',
  'students.import.createClasses': 'إنشاء الشعب غير الموجودة تلقائياً',
  'students.import.createClassesHint': 'للمدير أو المالك فقط.',
  'students.import.classesToCreate': 'ستُنشأ هذه الشعب: {list}',
  'students.import.viewStudents': 'عرض الطلاب',
  'students.import.issue.noGrade': 'لا يوجد الصف {grade} في المدرسة',
  'students.import.issue.sameCode': 'الرمز مكرر مع السطر {row}',
  'students.import.issue.codeExists': 'الرمز {code} مستخدم لطالب آخر',
  'students.import.issue.noClass': 'لا توجد شعبة {name} هذه السنة',
  'students.field.code': 'الرمز',
  'students.field.nameAr': 'اسم الطالب',
  'students.field.nameEn': 'الاسم بالإنجليزية',
  'students.field.gender': 'الجنس',
  'students.field.birthDate': 'تاريخ الميلاد',
  'students.field.grade': 'الصف',
  'students.field.section': 'الشعبة',
  'students.field.stream': 'الفرع',
  'students.field.guardianName': 'اسم ولي الأمر',
  'students.field.guardianPhone': 'هاتف ولي الأمر',
  'students.field.guardianRelation': 'صلة القرابة',
  'students.field.openingBalance': 'ديون سابقة',
  'students.field.openingBalanceNote': 'ملاحظة الديون',
  'students.import.issue.paidMore': 'المدفوع أكثر من المستحق ({due})',
  'students.import.totals': 'سيُقيَّد: رسوم هذه السنة {fees}، ديون سابقة {opening}، مدفوع هذه السنة {paid}.',
  'students.field.paidBefore': 'المدفوع هذه السنة',
} as const;
